export default __webpack_public_path__ + "static/media/15.eaca5460.jpg";